export default [
  {
    title: 'Welcome',
    element: '.none',
    text: 'Welcome to {{wlName}}, your medical image sharing platform. In this tour we will help you getting started.',
    placement: {
      relativeTo: 'viewport',
      position: 'center center'
    }
  },
  {
    title: 'Medical results',
    element: '.icons-layout',
    text: 'Here you will find all the folders, documents and medical results that are shared with you.',
    placement: {
      relativeTo: 'viewport',
      position: 'center center'
    }
  },
  {
    title: 'No results yet',
    element: '.empty-folder',
    text: 'It seems that your results have not been uploaded yet. This process may take several days.',
    placement: {
      relativeTo: 'element',
      position: 'right top'
    }
  },
  {
    title: 'Viewing files',
    element: '.icon-wrapper-file',
    text: 'You can <strong>double click</strong> to enter folders or open files.',
    placement: {
      relativeTo: 'element',
      position: 'right top'
    }
  }
]



// WEBPACK FOOTER //
// ./src/components/common/tour/tours/desktop/en-US/guestTour.js